import { styled, Flex, Box } from '@grupoboticario/flora-react'

export const ProductCardWrapper = styled(Flex, {
  padding: '$4 0',
})

export const ProductCardImageWrapper = styled(Box, {
  flex: '1 0 auto',
  textAlign: 'center',
  width: 40,
})

export const ProductCardImage = styled(Flex, {
  width: 40,
  height: 40,
  overflow: 'hidden',
})

export const ProductCardContent = styled(Box, {
  padding: '0 $2',
  width: '100%',
})

export const ProductCardAction = styled(Flex, {
  flex: '1 0 auto',
  alignItems: 'flex-start',
  width: 90,
})
